import { InfoBadge } from '@investoro/core';

export default InfoBadge;
